import moment from 'moment-timezone';

/** Общие методы для работы с датами без зависимостей от сущностей. */
export default class DateHelper {
  /**
   * Простое форматирование даты.
   * @param {any} value
   * @returns {string}
   */
  static formatDate(value) {
    return value ? moment(value).format('YYYY-MM-DD') : null;
  }

  /**
   * Приводит диапазоны дат в массиве к стандартному виду и преобразует значения в даты.
   * @param {any[]} dateRanges
   * @param fromField
   * @param toField
   * @returns {DateRange[]}
   */
  static formatDateRanges(dateRanges, fromField = 'from', toField = 'to') {
    return dateRanges.map(range => ({
      from: new Date(range[fromField]),
      to: new Date(range[toField]),
    }));
  }

  /**
   * Метод для подсчета кол-ва определенных дней недели в периоде.
   * Длительность периода не влияет на скорость работы.
   * Источник: https://stackoverflow.com/a/25672779/19939388
   * @param {number[]} weekdays
   * @param {Date} dateFrom
   * @param {Date} dateTo
   * @returns {number}
   */
  static countCertainDays(weekdays, dateFrom, dateTo) {
    const totalDays = 1 + Math.round((+dateTo - +dateFrom) / (24 * 3600 * 1000));
    return weekdays.reduce((sum, currentWeekday) => (
      sum + Math.floor((totalDays + ((dateFrom.getDay() + 6 - currentWeekday) % 7)) / 7)
    ), 0);
  }

  /**
   * Объединяет пересекающиеся диапазоны дат в массиве
   * @param {DateRange[]} dateRanges
   * @returns {DateRange[]}
   */
  static mergeDateRanges(dateRanges) {
    if (!dateRanges.length) return [];

    // Сортируем диапазоны по начальной дате
    dateRanges.sort((a, b) => +a.from - +b.from);

    return dateRanges.reduce((mergedRanges, currentRange) => {
      const lastMergedRange = mergedRanges[mergedRanges.length - 1];

      if (currentRange.from <= lastMergedRange.to) {
        // Если есть пересечение с прошлым диапазоном, то объединяем их
        lastMergedRange.to = new Date(Math.max(+lastMergedRange.to, +currentRange.to));
      } else {
        // Иначе создаем новый объединенный диапазон
        mergedRanges.push(currentRange);
      }

      return mergedRanges;
    }, [dateRanges[0]]);
  }

  /**
   * @param {string} beginTime - время начала занятия
   * @param {number} interval - интервал (в минутах)
   * @returns {string} время конца занятия
   */
  static getLessonEndTime(beginTime, interval) {
    const endTime = moment(`1990-01-01 ${beginTime}`).add(interval, 'minutes');
    return endTime.isSameOrAfter(moment('1990-01-02 00:00')) ? '23:59' : endTime.format('HH:mm');
  }
}
